<template>
  <div class="recommend-link-template" theme>
    <div id="recommend-link-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: '',
      parts: [
        {
          elem: '#recommend-link-content',
          htmlFile: 'recommend'
        }
      ]
    }
  }
}
</script>
